import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  FiscalYearBean,
  FiscalYearSearchCriteria,
  RestFiscalYearListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DatePickerComponent,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class FiscalYearListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }

  componentDidMount() {}

  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  editFiscalYear = (e, val, rowData) => {
    if (e.detail === 1) this.props.editFiscalYear(val, rowData);
  };
  clickGoButton = (e) => {
    if (e.detail === 1) this.props.clickGoButton();
  };
  deleteFiscalYear = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteFiscalYear(val, rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let fiscalYear_list = this.props.fiscalYear_list;
    let fiscalYearData = this.props.fiscalYearData;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">Fiscal Year</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                type="text"
                name="code"
                onChange={this.onChange}
                value={fiscalYearData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.clickGoButton(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "startDate")}>
                  StartDate{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "startDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "endDate")}>
                  EndDate{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "endDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {fiscalYear_list.map((Info, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.editFiscalYear(e, Info.code)}
                    >
                      {Info.code}
                    </Button>
                  </td>

                  <td> {Info.startDate}</td>
                  <td> {Info.endDate}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.isActive}</td>
                  <td className="text-right">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.deleteFiscalYear(e, Info.code, Info)}
                    >
                      {<DeleteIcon />}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {fiscalYear_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class FiscalYearEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  render() {
    let fiscalYearData = this.props.fiscalYearData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={fiscalYearData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Fiscal Year Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter FiscalYearCode"
              onChange={this.onChange}
              value={fiscalYearData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Start Date</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <DatePickerComponent
              name="startDate"
              value={fiscalYearData.startDate}
              onChange={this.onChange}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>End Date</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <DatePickerComponent
              name="endDate"
              value={fiscalYearData.endDate}
              onChange={this.onChange}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={fiscalYearData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class FiscalYearList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      fiscalYear_list: [],
      response: {},
      pageTitle: "Fiscal Year ",
      fiscalYearData: new FiscalYearBean(),
      pageList: new PageListBean(),
      criteria: new FiscalYearSearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      totalCount: 0,
      isFiscalYearListFormOpen: true,
      isFiscalYearEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowCode: false,
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
    this.moduleCaption = " Fiscal Year";
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let fiscalYearData = new FiscalYearBean();
    fiscalYearData.companyCode = this.companyCode;
    this.setState({ fiscalYearData: fiscalYearData });
    this.loadPage(1);
    this.cleardata();
  }

  cleardata = () => {
    let fiscalYearData = new FiscalYearBean();
    fiscalYearData.companyCode = this.companyCode;
    this.setState({ fiscalYearData: fiscalYearData });
  };
  saveFiscalYearResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeFiscalYearEntryForm();
  };

  saveFiscalYear = () => {
    let input = this.state.fiscalYearData;
    if (input.isFetched == true) {
      if (SecurityAccessManager.FiscalYearMaintenanceEdit_IsAccessible()) {
        MasterService.updateFiscalYear(
          input,
          this.saveFiscalYearResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.FiscalYearMaintenanceCreate_IsAccessible()) {
        MasterService.createFiscalYear(
          input,
          this.saveFiscalYearResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  editFiscalYearResponse = (response) => {
    if (response.data != null) {
      if (response.data.fiscalYear != null) {
        let fiscalYearData = response.data.fiscalYear;
        this.setState({
          fiscalYearData: fiscalYearData,
        });
        this.disable();
      }
      this.openFiscalYearEntryForm();
    }
  };

  editFiscalYear = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (SecurityAccessManager.FiscalYearMaintenanceView_IsAccessible()) {
      MasterService.readFiscalYear(
        readrestInput,
        this.editFiscalYearResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  deleteFiscalYear = (val, rowData) => {
    //
  };
  clickGoButton = () => {
    let fiscalYearData = this.state.fiscalYearData;
    this.editFiscalYear(fiscalYearData.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.clickGoButton();
    }, 200);
  };

  onChange = (e) => {
    let fiscalYearData = this.state.fiscalYearData;
    fiscalYearData[e.target.name] = e.target.value;
    this.setState({ fiscalYearData: fiscalYearData });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  save = () => {
    this.saveFiscalYear();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeFiscalYearEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  openFiscalYearEntryForm = () => {
    this.setState({
      isFiscalYearListFormOpen: false,
      isFiscalYearEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeFiscalYearEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isFiscalYearListFormOpen: true,
      isFiscalYearEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isDisableFields: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadFiscalYearResponse = (response) => {
    if (response.data != null && response.data.fiscalYearPageList != null) {
      let fiscalYears = new Array();
      if (!isEmptyArray(response.data.fiscalYearPageList.fiscalYears)) {
        fiscalYears = response.data.fiscalYearPageList.fiscalYears;
        fiscalYears.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount = response.data.fiscalYearPageList.totalCount;
      pageList.currentPage = response.data.fiscalYearPageList.currentPage;
      pageList.pageSize = response.data.fiscalYearPageList.pageSize;
      this.setState({
        fiscalYear_list: fiscalYears,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new FiscalYearSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadFiscalYearPage(pageInput, criteria);
  };
  loadFiscalYearPage = (pageList, searchCriteria) => {
    let requestInput = new RestFiscalYearListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = searchCriteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.FiscalYearMaintenanceView_IsAccessible()) {
      MasterService.getFiscalYearsPageList(
        requestInput,
        this.loadFiscalYearResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.fiscalYear_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ fiscalYear_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}

        {this.state.isFiscalYearListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isFiscalYearListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isFiscalYearListFormOpen && (
          <FiscalYearListForm
            {...this.state}
            onChange={this.onChange}
            editFiscalYear={this.editFiscalYear}
            clickGoButton={this.clickGoButton}
            enterKeyEventHandler={this.enterKeyEventHandler}
            deleteFiscalYear={this.deleteFiscalYear}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isFiscalYearEntryFormOpen && (
          <FiscalYearEntryForm {...this.state} onChange={this.onChange} />
        )}
      </div>
    );
  }
}

function FiscalYearAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <FiscalYearList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default FiscalYearAttributeModule;
